import { ActionReducer, ActionReducerMap, MetaReducer, UPDATE } from '@ngrx/store'

import { StoreToken } from './enums/store-tokens.enum'
import { metricFinderReducer } from './reducers/metric-finder.reducer'
import { MatchMetricFinderEffects } from './effects/match-metric-finder.effects'
import { PlayerMetricFinderEffects } from './effects/player-metric-finder.effects'
import { TeamMetricFinderEffects } from './effects/team-metric-finder.effects'
import { ContextMenuEffects } from '@core/store/effects/context-menu.effects'
import { userReducer } from '@core/store/reducers/user.reducer'
import { AuthEffects } from '@core/store/effects/auth.effects'
import { ProfileEffects } from '@core/store/effects/profile.effects'
import { ErrorEffects } from '@core/store/effects/error.effects'
import { socketReducer } from '@core/store/reducers/socket.reducer'
import { SocketEffects } from '@core/store/effects/socket.effects'
import { RECOMPUTE } from '@ngrx/store-devtools'
import { signOutSuccess } from '@core/store/actions/auth.actions'
import { setTopic } from '@core/store/actions/socket.actions'

export const rootReducers: ActionReducerMap<any> = {
  [StoreToken.metricFinder]: metricFinderReducer,
  [StoreToken.user]: userReducer,
  [StoreToken.socket]: socketReducer
}

export const clearStateMetaReducer = (reducer: ActionReducer<any>): ActionReducer<any> =>
  function (state, action) {
    if (action.type === signOutSuccess.type) {
      state = {}
    }
    return reducer(state, action)
  }

export const debug = (reducer: ActionReducer<any>): ActionReducer<any> =>
  function (state, action) {
    if (![UPDATE, RECOMPUTE as string].includes(action.type) && action.type === setTopic.type) {
      //console.log('action', action)
    }
    return reducer(state, action)
  }

export const rootMetaReducers: MetaReducer[] = [clearStateMetaReducer, debug]

export const rootEffects = [
  MatchMetricFinderEffects,
  PlayerMetricFinderEffects,
  TeamMetricFinderEffects,
  ContextMenuEffects,
  ProfileEffects,
  AuthEffects,
  ErrorEffects,
  SocketEffects
]
